<template>
  <div class="page-view home" v-show="loadReady">
    <div class="top fx fx-between fx-items-center">
      <img class="top-bg" src="@/assets/img/home-bg.jpg">
      <div class="header fx fx-between fx-items-center">
        <div class="fx fx-items-center">
          <img class="app-logo" src="@/assets/img/UgiftLogoTM.png">
          <img class="app-title" src="@/assets/img/app-title.png">
        </div>
        <div class="market-group fx fx-between fx-items-center">
          <img class="app-mine" src="@/assets/img/mine.png" @click="onMineTap">
          <div class="line"></div>
          <img class="m-img" :src="marketImg" @click="onMarketTap">
        </div>
      </div>
    </div>
    <div class="banner">
      <van-image
        class="preload-img"
        :width="swiperWidth"
        :height="swiperHeight"
        v-if="loading"
      />
      <van-swipe :autoplay="3000" indicator-color="white" v-if="!loading && pageData.swiper">
        <van-swipe-item v-for="item in pageData.swiper.advertList" :key="item.advertId">
          <van-image :src="item.picUrl" @click="onBannerTap(item.jumpType, item.jumpInfo.url)"/>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="content">
      <div class="select-items">
        <div class="brands">
          <!-- <div class="fx fx-end">
            <div class="my-gifts fx fx-items-center" @click="onMineTap"><van-icon name="point-gift" size="15" />My Pocket</div>
          </div> -->
          <!-- 品牌骨架屏 -->
          <div class="fx" v-if="loading">
            <div class="item fx fx-center fx-column fx-items-center">
              <van-image round :width="50" :height="50" />
              <div class="brand-name tit-gray">--</div>
            </div>
            <div class="item fx fx-center fx-column fx-items-center">
              <van-image round :width="50" :height="50" />
              <div class="brand-name tit-gray">--</div>
            </div>
            <div class="item fx fx-center fx-column fx-items-center">
              <van-image round :width="50" :height="50" />
              <div class="brand-name tit-gray">--</div>
            </div>
            <div class="item fx fx-center fx-column fx-items-center">
              <van-image round :width="50" :height="50" />
              <div class="brand-name tit-gray">--</div>
            </div>
          </div>
          <!-- 品牌列表 -->
          <div class="fx" v-if="!loading && pageData.brands">
            <div class="item fx fx-center fx-column fx-items-center" v-for="(item, index) in pageData.brands.advertList" :key="item.optionValue"
              @click="brandTap(index, item.listId, item.listType)">
              <van-image
                class="brand-icon"
                round
                :width="50"
                :height="50"
                :src="item.listUrlImage"
              />
              <p class="brand-name tit-gray">{{item.listName}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 货架骨架屏 -->
      <div class="card-group" v-if="loading">
        <div class="item">
          <p class="group-title bold">--</p>
          <div class="fx fx-wrap">
            <div class="card-item">
              <van-image :width="cardWidth" :height="cardHeight" />
              <p class="text-center tit-gray">--</p>
            </div>
            <div class="card-item">
              <van-image :width="cardWidth" :height="cardHeight" />
              <p class="text-center tit-gray">--</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 货架列表 -->
      <div class="card-group" v-if="!loading && pageData.cardGroup">
        <div class="item" v-for="item in pageData.cardGroup" :key="item.spaceId">
          <p class="group-title bold">{{item.spaceName}}</p>
          <div class="fx fx-wrap">
            <div class="card-item"
              v-for="card in item.advertList"
              :key="card.advertId"
              @click="onCardTap(card.listId, card.listType)">
              <img :src="card.listUrlImage" alt="">
              <p class="text-center tit-gray">{{card.listName}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="gray fx fx-center">
          <span class="l" @click="footerTap(0)">CONTACT US</span>&emsp;<span class="r" @click="footerTap(1)">T & C</span>
        </div>
      </div>
    </div>
    <van-dialog v-model="footerDialog" confirm-button-text="OK" :close-on-click-overlay="true" :close-on-popstate="true">
      <div class="dialog-cnt">
        <div v-if="showContact">
          <p>
            Please contact us with below Email if you met any issues, our support will reply you as soon as we can.
          </p>
          <p class="blue copytext" data-clipboard-action="copy"
              data-clipboard-text="ugiftsupport@e-buy.com"
              @click="onEmailTap()">ugiftsupport@e-buy.com</p>
        </div>
        <div v-else>
          <data-conditions></data-conditions>
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="newGuestDialog" :show-confirm-button="false" :close-on-click-overlay="true" :close-on-popstate="true">
      <div class="gift-dialog-cnt">
        <p class="title">New Customer Welcome Gift</p>
        <p class="info">Has been recevied</p>
        <div class="list">
          <div class="gift-item fx" v-for="item in newGuestGift" :key="item.giftName">
            <van-image :src="item.giftUrlImage" width="45" />
            <div>
              <p class="name">{{item.giftName}}</p>
              <p class="price">
                <span class="red">{{item.currency | unitFormat}}{{item.priceReal | numFormat(2)}}</span>
                <span class="gray">{{item.currency | unitFormat}}{{item.priceSale | numFormat(2)}}</span>
              </p>
              <p class="desc gray">{{item.giftTypeDesc}}</p>
            </div>
          </div>
        </div>
        <van-button type="primary" size="large" @click="checkGift">
          Go to "My Gift" to check Now
        </van-button>
      </div>
    </van-dialog>
    <van-dialog v-model="marketDialog" :show-confirm-button="false" :close-on-click-overlay="true" :close-on-popstate="true">
      <div class="market-dialog-cnt">
        <p class="title">Change Market</p>
        <div class="item fx fx-between fx-items-center" v-for="item in marketItems" :key="item.marketCode" @click="changeMarket(item)">
          <div class="fx fx-items-center">
            <van-image :src="item.marketUrlImage" width="30" />
            <div>{{item.marketName}}</div>
          </div>
          <van-icon name="checked" size="20" color="#388BFF" v-if="pageContentParams.pageName.includes(item.marketCode)"/>
          <van-icon name="checked" size="20" color="#dbdbdb" v-else/>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      homeBg: {
        'background': 'url(' + require('@/assets/img/home-bg.jpg') + ') no-repeat',
        'background-size': '100% auto'
      },
      loading: true,
      swiperWidth: '',
      swiperHeight: '',
      cardWidth: '',
      cardHeight: '',
      footerDialog: false,
      newGuestDialog: false,
      marketDialog: false,
      newGuestGift: [],
      showContact: false,
      pageContentParams: {
        pageName: 'HOME_SG'
      },
      pageData: {
        swiper: [],
        goods: [],
        brands: [],
        cardGroup: []
      },
      loadReady: false,
      marketImg: '',
      marketItems: [],
      currentMarket: ''
    }
  },
  watch: {

  },
  created () {
    // banner尺寸 480*278
    this.swiperWidth = this.$util.getWw() - 30
    this.swiperHeight = this.swiperWidth * 278 / 480
    this.cardWidth = (this.$util.getWw() - 30) * 0.48
    this.cardHeight = this.cardWidth * 278 / 480
    // 新客有礼
    const token = this.$util.storageGet('local', 'token')
    const isNewGuest = this.$util.storageGet('local', 'isNewGuest')
    if (token && isNewGuest === 'false') {
      this.getNewGuestGift(token)
    }
    // 获取所有市场
    this.getListMarket({}).then((d) => {
      if (d.success) {
        this.marketItems = d.content.marketList
        let code = this.$route.query.code
        if (code) {
          this.$util.storageSet('local', 'phoneCode', code)
          this.$Staticdata.data.countrys.map((v) => {
            if (v.value === code) {
              this.$util.storageSet('local', 'marketCode', v.market)
              this.$util.storageSet('local', 'country', v.text)
              let find = this.marketItems.find(ele => ele.marketCode === v.market)
              this.$util.storageSet('local', 'marketImg', find.marketUrlImage)
              this.$util.storageSet('local', 'marketId', find.marketId)
              this.pageContentParams.pageName = v.market
            }
          })
        }
        this.marketImg = this.$util.storageGet('local', 'marketImg')
        let m = this.$util.storageGet('local', 'marketCode')
        this.pageContentParams.pageName = m ? 'HOME_' + m : 'HOME_SG'
        this.loadData()
      }
    })
  },
  methods: {
    // 获取首页展示数据
    getPageContent (params) {
      return this.$http.post('/olvp/getPageContent', 'getPageContent', params)
    },
    getMemberPushMsg (params) {
      return this.$http.post('/olvp/getMemberPushMsg', 'getMemberPushMsg', params, {
        appName: 'paas-app-olvp'
      })
    },
    // 获取所支持市场列表
    getListMarket (params) {
      return this.$http.post('/olvp/getListMarket', 'getListMarket', params, false, false)
    },
    changeMarket (e) {
      this.pageContentParams.pageName = `HOME_${e.marketCode}`
      this.$util.storageSet('local', 'marketId', e.marketId) // 用于获取支付渠道
      this.$util.storageSet('local', 'marketCode', e.marketCode) // 用于获取市场货架
      this.$util.storageSet('local', 'marketImg', e.marketUrlImage)
      this.marketImg = e.marketUrlImage
      this.loadData()
      this.marketDialog = false
    },
    // 切换城市
    onMarketTap () {
      this.marketDialog = true
    },
    // 新客有礼
    getNewGuestGift (e) {
      const params = {
        token: e
      }
      this.getMemberPushMsg(params).then((d) => {
        if (d.success && d.content.msgList.length > 0) {
          this.newGuestGift = d.content.msgList[0].msgData.giftList
          this.newGuestDialog = true
          this.$util.storageSet('local', 'isNewGuest', 'true')
        }
      })
    },
    checkGift () {
      this.newGuestDialog = false
      this.$router.push('/myGiftCard')
    },
    loadData () {
      this.getPageContent(this.pageContentParams).then((d) => {
        if (d.success) {
          this.loadReady = true
          this.pageData.swiper = d.content.advertSpaceDtoList[0]
          this.pageData.brands = d.content.advertSpaceDtoList[1]
          this.pageData.cardGroup = d.content.advertSpaceDtoList.splice(2)
          this.loading = false
        }
      })
    },
    // 跳转品牌商品列表
    brandTap (i, listId, listType) {
      this.$router.push(`/brandGoods?id=${listId}&type=${listType}`)
    },
    // banner跳转
    onBannerTap (type, url) {
      if (url) {
        const token = this.$util.storageGet('local', 'token') || ''
        if (!token) {
          this.$cux.confirm({
            message: 'Please login to proceed.',
            confirmButtonText: 'Sign-up/Login',
            cancelButtonText: 'Cancel'
          }).then(() => {
            this.$router.push(`/login?backPath=${encodeURIComponent(this.$route.fullPath)}`)
          })
        } else {
          if (type === 'inside') { // 项目下路由跳转
            this.$router.push('/' + url)
          } else { // 跳转外链
            window.location.href = url
          }
        }
      }
    },
    // 购买礼品卡
    onCardTap (listId, listType) {
      this.$router.push(`/buyGiftCard?id=${listId}&type=${listType}`)
    },
    // 点击我的 检查登录状态
    onMineTap () {
      const token = this.$util.storageGet('local', 'token') || ''
      if (!token) {
        this.$cux.confirm({
          message: 'Please login to proceed.',
          confirmButtonText: 'Sign-up/Login',
          cancelButtonText: 'Cancel'
        }).then(() => {
          this.$router.push(`/login?backPath=${encodeURIComponent(this.$route.fullPath)}`)
        })
      } else {
        this.$router.push(`/myGiftCard`)
      }
    },
    footerTap (e) {
      this.footerDialog = true
      if (e === 0) {
        this.showContact = true
      } else {
        this.showContact = false
      }
    },
    onEmailTap () {
      let self = this
      let clipboard = new this.$clipboard('.copytext')
      clipboard.on('success', function () {
        self.$cux.toast({
          message: 'Address is Copied.',
          type: 'success'
        })
      })
      clipboard.on('error', function () {
        // console.log('复制失败')
      })
    }
  },
  mounted () {

  },
  computed: {

  }
}
</script>

<style lang="scss">
  .home {
    height: 100%;
    background: #f5f5f5;
    .market-dialog-cnt {
      max-height: 70vh;
      padding: 20px;
      .title {
        margin-bottom: 20px;
        font-weight: 500;
      }
      .item {
        font-size: 14px;
        padding: 8px 0;
        .van-image {
          border-radius: 50%;
          border: 1px solid #ccc;
          margin-right: 10px;
        }
      }
    }
    .market-group {
      width: 135px;
      background: #428ff7;
      border-radius: 30px;
      padding: 5px;
      .line {
        background: #bfdbfc;
        width: 1px;
        height: 20px;
      }
    }
    .van-swipe {
      .van-image {
        width: 100%;
      }
    }
    .header {
      z-index: 9;
      width: 100%;
    }
    .dialog-cnt {
      padding: 20px;
      max-height: 70vh;
      overflow: scroll;
      .blue {
        margin-top: 10px;
      }
    }
  }
  .top {
    padding: 15px;
    position: relative;
    .top-bg {
      position: absolute;
      top: 0;
      left: 0;
    }

    .app-logo {
      width: 55px;
      height: 55px;
      margin-right: 15px;
      z-index: 99;
      border-radius: 50%;
    }
    .app-title {
      width: 50%;
      z-index: 99;
    }
    .app-mine {
      width: 35px;
      height: 35px;
    }
    .m-img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: 3px solid #bfdbfc;
    }
  }

  .banner-title {
    font-size: 15px;
    padding: 0 20px 8px 20px;
    color: #fff;
    span {
      margin-left: 10px;
    }
  }

  .location {
    color: #fff;
    background: #388BFF;
    border-radius: 30px;
    padding: 4px 6px 4px 4px;
    .current-country {
      margin: 0 5px;
    }

    .country-icon {
      width: 18px;
      height: 19px;
      margin-right: 4px;
    }
  }

  .banner {
    padding: 0 15px;
    margin-top: 10px;
    background: #fff;
    img {
      border-radius: 8px;
    }
    .preload-img {
      border-radius: 8px;
      overflow: hidden;
    }
  }

  .content {
    background: #f5f5f5;
    .title {
      margin-bottom: 20px;
    }

    .my-gifts {
      background: #fff;
      box-shadow: 2px 2px 5px #64b5f6;
      padding: 8px 12px;
      border-radius: 20px;
      background: rgb(91, 169, 255);
      color: #fff;
      margin-bottom: 15px;
      .van-icon {
        margin-right: 5px;
      }
    }
    .select-items {
      padding: 25px 15px 15px 15px;
      background: #fff;
      box-shadow: 0 20px 20px #eeeeee;
    }
    .brands {
      overflow-x: scroll;
      .item {
        width: 80px;
        .brand-icon {
          border: 1px solid #f4f4f4;
        }
        .brand-name {
          width: 80px;
          font-size: 12px;
          margin-top: 6px;
          text-align: center;
          border-right: 1px dashed #ccc;
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
          padding: 0 4px;
        }
      }
      .item:last-child .brand-name {
        border-right: 0;
      }
    }

    .card-group {
      padding: 15px;
      .item {
        .group-title {
          font-size: 15px;
          margin: 20px 0;
        }
        .card-item {
          width: 48%;
          background: #fff;
          border-radius: 5px;
          box-shadow: 0 2px 8px #ccc;
          margin-bottom: 15px;
          overflow: hidden;
          p {
            padding: 8px;
            width: 100%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
        .card-item:nth-child(odd) {
          margin-right: 4%;
        }
      }
    }

    .vouchers {
      padding: 10px 0 60px 0;

      .item {
        margin-bottom: 16px;

        .voucher-name {
          font-size: 17px;
          margin-top: 8px;
        }
      }

      .nothing {
        padding: 20px;
      }
    }

  }
  .footer {
    padding: 30px;
    font-size: 12px;
  }

  .gift-dialog-cnt {
    background: #388BFF;
    padding: 15px;
    .list {
      max-height: 40vh;
      overflow-y: scroll;
    }
    .title {
      font-size: 16px;
      text-align: center;
      color: #fff;
      font-weight: bold;
      padding: 8px 0;
    }
    .info {
      font-size: 12px;
      color: #fff;
      text-align: center;
      margin-bottom: 12px;
    }
    .van-button {
      box-shadow: none;
      margin-top: 12px;
      border-radius: 30px;
    }
    .gift-item {
      background: #fff;
      border-radius: 5px;
      padding: 15px;
      margin-bottom: 12px;
      .van-image {
        margin-right: 10px;
      }
      .name {
        font-size: 14px;
      }
      .desc {
        font-size: 12px;
      }
      .price {
        font-size: 12px;
        margin-top: 5px;
        .gray {
          text-decoration: line-through;
        }
      }
    }
    .gift-item:last-child {
      margin-bottom: 0;
    }
  }
</style>
